// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

// lang.js
export const SET_LOCALE = 'SET_LOCALE'

// common.js
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const SET_BREADCRUMBS = 'SET_BREADCRUMBS'

// api.js
export const FETCH_PERMISSIONS = 'FETCH_PERMISSIONS'
export const FETCH_ROLES = 'FETCH_ROLES'
export const FETCH_STATUSES = 'FETCH_STATUSES'
export const FETCH_DIRECTIONS = 'FETCH_DIRECTIONS'
export const FETCH_DOCUMENTS = 'FETCH_DOCUMENTS'
export const FETCH_EDUCATION_TYPES = 'FETCH_EDUCATION_TYPES'
export const FETCH_EDUCATION_METHODS = 'FETCH_EDUCATION_METHODS'
export const FETCH_USERS = 'FETCH_USERS'
export const FETCH_QUESTION_TYPES = 'FETCH_QUESTION_TYPES'
export const FETCH_TEST_TYPES = 'FETCH_TEST_TYPES'
export const FETCH_SUBJECT_TYPES = 'FETCH_SUBJECT_TYPES'
export const FETCH_ATTEMPT_QUESTION_STATUSES = 'FETCH_ATTEMPT_QUESTION_STATUSES'
export const FETCH_DOCUMENTS_STATUSES = 'FETCH_DOCUMENTS_STATUSES'
export const FETCH_POLL_STATUSES = 'FETCH_POLL_STATUSES'
